


























import Vue, { PropType } from 'vue';
export default Vue.extend({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    next: {
      type: Function,
      required: true
    },

    errors: {
      type: Array as PropType<string[]>,
      default: []
    }
  }
});
